<template>
  <section class="apply_mess">
    <template v-if="showApplyInput">
      <h3 v-if="$store.state.common.theme !=3">填写申请信息</h3>
      <section :class="$store.state.common.theme !=3 ? 'mess_list' :'mess_list mess_list_3'">
        <section :class="$store.state.common.theme !=3 ? 'mess_list_item' :'mess_list_item mess_list_item_3'">
          <p class="list_item_left">
            申请人
            <span>*</span>
          </p>
          <input
            class="list_item_right"
            type="text"
            v-model="userName"
            @input="nameInputFun"
            placeholder="请输入真实姓名或公司名称"
          />
        </section>
        <section :class="$store.state.common.theme !=3 ? 'mess_list_item' :'mess_list_item mess_list_item_3'">
          <p class="list_item_left">
            联系方式
          </p>
          <input
            class="list_item_right"
            type="text"
            v-model="otherPhone"
            placeholder="请输入联系方式"
            @input="otherPhoneInputFun"
          />
        </section>
        <section class="mess_list_item">
          <p class="list_item_left">
            生效开始
            <span>*</span>
          </p>
          <p
            @click="selectTime(1)"
            :class="['list_item_right','list_item_right_p',startTime?'':'placeholder']"
          >{{startTime?startTime:'请选择开始日期'}}</p>
          <img src="../../../assets/images/icon_indicator_next.png" />
        </section>
        <section :class="$store.state.common.theme !=3 ? 'mess_list_item' :'mess_list_item mess_list_item_3'" v-if="parkingMess.monthType!=2">
          <p class="list_item_left">
            租赁期
            <span>*</span>
          </p>
          <p
            @click="select()"
            :class="['list_item_right','list_item_right_p','last',applyCount?'':'placeholder']"
          >{{applyCount?applyCount:'请选择停车月数'}}</p>
          <img src="../../../assets/images/icon_indicator_next.png" />
        </section>
        <section :class="$store.state.common.theme !=3 ? 'mess_list_item' :'mess_list_item mess_list_item_3'" v-else>
          <p class="list_item_left">
            租赁期

          </p>
          <p
            :class="['list_item_right','list_item_right_p','last',]"
          >{{applyCountText}}</p>
          <img src="../../../assets/images/icon_indicator_next.png" />
        </section>
        <section :class="$store.state.common.theme !=3 ? 'mess_list_item' :'mess_list_item mess_list_item_3'">
          <p class="list_item_left">
            生效结束
            <span>*</span>
          </p>
          <p
            @click="selectTime(2)"
            :class="['list_item_right','list_item_right_p','last',endTime?'':'placeholder']"
          >{{endTime?endTime:'请选择结束日期'}}</p>
          <img src="../../../assets/images/icon_indicator_next.png" />
        </section>
        <section class="mess_list_item" v-if="parkingMess.showParkingNumber == 1">
          <p class="list_item_left">
            车位号
            <span>*</span>
          </p>
          <!-- type="number" -->
          <input
            class="list_item_right"
            v-model="parkingNumber"
            @input="parkingNumberInputFun"
            placeholder="请输入车位号"
          />
        </section>
      </section>
      <yd-datetime
        style="display:none;"
        ref="datetime_date"
        @input="dateChange"
        type="date"
        v-model="date"
        :startDate="curDate"
        :endDate="maxDate"
      ></yd-datetime>
      <yd-datetime
        style="display:none;"
        ref="datetime_month"
        @input="dateChange"
        type="month"
        v-model="date_m"
        :startDate="curDate"
        :endDate="maxDate"
      ></yd-datetime>
    </template>
    <template v-else>
      <section class="end_time">
        <img src="../../../assets/images/warning.jpg" />
        <p>该月卡优惠将于{{maxEndDay|formatTime(181)}}结束</p>
      </section>
    </template>

     <mt-popup  v-model="popupVisible" position="bottom" class="mint-popup">
      <mt-picker class="picker" :slots="pickList" @change="onValuesChange" :visible-item-count="5" :show-toolbar="true" ref="picker" >
            <div class="picker_wrap">
                <div class="picker_btn" @click="popupVisible=false">取消</div>
                <div class="picker_btn2" @click="handleConfirm">确认</div>
            </div>
            </mt-picker>
    </mt-popup>
  </section>


</template>

<script>
import util from '../../../utils/util';
import moment from 'moment'
export default {
  data() {
    return {
      date: '',
      date_m: '',
      startDate: null,
      timeT: 1,//区分点击哪个选择时间控件
      startTime: '',
      endTime: '',
      userName: '',
      parkingNumber:'',
      otherPhone: '',
      applyCount:0,//期数
      applyCountText:'',
      userS: false,
      //弹框选择

      Qishulist: [{
        flex: 1,
        values:[1] ,
        className: 'slot1',
        textAlign: 'center'
      }],
      pickType:'',
      popupVisible:false,
      pickList:[],
    }
  },
  props: {
    showApplyInput: { type: Boolean, default: true },
    maxEndDay: { type: Number, default: 9640880000000 },
    name: { type: String, default: '' },
    parkNum: { type: String, default: '' },
    phone: {},
    parkingMess: {
      type: Object,
      default: () => { }
    },
    applyData: {
      type: Object,
      default: () => { }
    },
    come: {
      type: String,
      default: ''
    },
    prkParkFeeBean:{
         type: Object,
          default: () => { }
    },
    editObject:{
      type: Object,
      default: () => { }
    }
  },
  watch: {
    maxEndDay() {
      this.endTime = ''
      this.startTime = ''
      this.date = '2020-01-01'
      this.date_m = '2050-01-01'
      this.userS = false
    },
    prkParkFeeBean(){
       this.endTime = ''
      this.startTime = ''
      this.applyCount=''
      this.applyCountText=''
      var list =[];
      for(var i=this.prkParkFeeBean.applyMinCount;i<=this.prkParkFeeBean.applyMaxCount;i++){
        list.push(i);
      }
      this.Qishulist[0].values =list
      console.log(this.prkParkFeeBean.applyMinCount, 'watch applyMinCount');
      console.log(this.prkParkFeeBean.applyMaxCount, 'watch applyMaxCount');
      console.log(JSON.stringify(this.Qishulist) ,'watch Qishulist');
    },


    editObject() {
      if (this.editObject) {
        console.log("in editObject  change" +JSON.stringify(this.editObject))

        this.userName = this.editObject.userName
        this.parkingNumber = this.editObject.parkingNumber
        this.otherPhone = this.editObject.otherPhone
        if(this.editObject.applyStartDay){
          var sDay =new Date(this.editObject.applyStartDay.replace(/\./g, '/'))
          this.startTime=  util.formatTime( sDay,4) 
        }
        if(this.editObject.applyEndDay){
          var sDay =new Date(this.editObject.applyEndDay.replace(/\./g, '/'))
          this.endTime = util.formatTime( sDay,4) 
        }
        if (this.parkingMess.monthType == 1) {
           if(this.editObject.applyDay){
            this.applyCount=this.editObject.applyDay
           }else{
             this.calculationMonthCount()
           }
            // var list =this.Qishulist[0].values;
            //计算结束日期
            this.calculationEndDate();
           
        }else{
          this.calculationApplyCount();
        }
      }
    }
  },
  computed: {
    curDate() {
      // 来自续签
      if (this.come == 'xuqian') {
        if (Object.keys(this.applyData).length <= 0) {
          return util.formatTime(new Date(), 19)
        }
        // 年月日格式
        let newD = this.applyData.prkParkApplyLogBeans.filter(item => {
          return item.applyStatus == 2 || item.applyStatus == 4
        })
        console.log(newD)
        let endDay = newD[0].applyEndDay;
        // 如果结束时间小于当前时间,取当前时间作为开始时间
        if (new Date(endDay.replace(/\./g, '/')).getTime() - new Date().getTime() < 0) {
          endDay = util.formatTime(new Date(), 9)
        }
        if (this.parkingMess.monthType == 2) {
          this.date = util.formatTime(new Date(new Date(endDay.replace(/\./g, '/')).getTime() + 1 * 1000), 4)
          return util.formatTime(new Date(new Date(endDay.replace(/\./g, '/')).getTime() + 1 * 1000), 19)
        } else {//年月格式
          let newD = new Date(endDay.replace(/\./g, '/'));
          newD = new Date(newD.valueOf() + 1 * 60 * 60 * 1000);
          console.log(util.formatTime(newD, 19))
          return util.formatTime(newD, 19)
        }
      } else {
        if( this.timeT ==1){
          return util.formatTime(new Date(), 20)
        }else{
          return util.formatTime(new Date(), 20)
        }
      }
    },
    maxDate() {
      if (Object.keys(this.parkingMess).length > 0) {
        let year, month, day;
        if (this.come == 'xuqian') {
          if (Object.keys(this.applyData).length <= 0) {
            console.log("maxday1 === " + JSON.stringify(util.formatTime(new Date(), 20)) )
            return util.formatTime(new Date(), 20)
          }
          let newD = this.applyData.prkParkApplyLogBeans.filter(item => {
            return item.applyStatus == 2 || item.applyStatus == 4
          })
          let endDay = newD[0].applyEndDay;
          // 如果结束时间小于当前时间,取当前时间作为开始时间
          if (new Date(endDay.replace(/\./g, '/')).getTime() - new Date().getTime() < 0) {
            endDay = util.formatTime(new Date(), 9)
          }
          year = util.formatTime(new Date(endDay.replace(/\./g, '/')), 17).year
          month = util.formatTime(new Date(endDay.replace(/\./g, '/')), 17).month
          day = util.formatTime(new Date(endDay.replace(/\./g, '/')), 17).day
        } else {
          year = util.formatTime(new Date(), 17).year
          month = util.formatTime(new Date(), 17).month
          day = util.formatTime(new Date(), 17).day
        }
        // 非整月模式且最大起租单位是日
       // console.log("parkingMess.monthType === " + this.parkingMess.monthType + "  " + this.parkingMess.applyMaxUnit)
        if (this.parkingMess.monthType == 2 && this.parkingMess.applyMaxUnit == 1) {
          // let time = new Date(year + '/' + month + '/' + day + ' 00:00:00').getTime() + (this.parkingMess.applyMaxCount - 1) * 24 * 60 * 60 * 1000;
          // // 判断最大时间是否大于价格期间的最大日期
          // if (time > this.maxEndDay) {
          //   time = this.maxEndDay
          // }
          // let d = util.formatTime(new Date(time), 20)
         // console.log("maxday4 === " + JSON.stringify(d) )
          // return d
          return util.formatTime(new Date(this.maxEndDay), 20)
        } else {
        //   let ys = parseInt((month - 0 + this.parkingMess.applyMaxCount - 1) / 12);
        //   year = year + ys;
        //  // console.log("this.parkingMess.applyMaxCount === " + this.parkingMess.applyMaxCount)
        //   let m = month - 1 + this.parkingMess.applyMaxCount - ys * 12;
        //   month = m >= 10 ? m : '0' + m
        //   console.log(year, month, day)
        //   let newSjc = new Date(year + '/' + month + '/' + day + ' 00:00:00').getTime();
        //  // console.log("newSjc  ===  " + JSON.stringify(util.formatTime(new Date(newSjc), 20)))
        //  // console.log("this.maxEndDay  ===  " + JSON.stringify(util.formatTime(new Date(this.maxEndDay), 20)))
        //   if (this.come != 'xuqian' && this.parkingMess.monthType == 2) {
        //     newSjc = newSjc - 24 * 60 * 60 * 1000;
        //   }
        //   if (newSjc > this.maxEndDay) {
        //     newSjc = this.maxEndDay
        //   }
         // console.log("maxday3 === " + JSON.stringify(util.formatTime(new Date(newSjc), 20)) )
          return util.formatTime(new Date(this.maxEndDay), 20)  //先使用车场最多日期
        }
      } else {
       // console.log("maxday3 ===  2100/01/01 00:00"   )
        return '2100/01/01 00:00'
      }
    },
    datetimeType() {
      // return 'date'
      if (this.parkingMess.startDateConf == 2) {
        return 'date'
      } else {
        return 'month'
      }
    }
  },
  created() {
    this.userName = this.name
    this.parkingNumber = this.parkNum
    var list =[];
    for(var i=this.prkParkFeeBean.applyMinCount;i<=this.prkParkFeeBean.applyMaxCount;i++){
        list.push(i);
    }
    this.Qishulist[0].values =list
    console.log(this.parkingMess, 'parkingMess');
    console.log(this.applyData, 'applyData');
    console.log(this.come, 'come');
    console.log(this.prkParkFeeBean.applyMinCount, 'applyMinCount');
    console.log(this.prkParkFeeBean.applyMaxCount, 'applyMaxCount');
    
    console.log(this.editObject, 'editObject');
    console.log(JSON.stringify(this.Qishulist) ,'Qishulist');
  },
  methods: {
    dateChange(val) {
      if (!this.userS) {
        return false;
      }
      if (this.timeT == '1') {
        this.startTime = val


        if(this.parkingMess.monthType==1){
          if(this.parkingMess.startDateConf==1){
            this.startTime = val+'-01'
          }
          this.calculationEndDate()  //计算结束日期
        }else{
          this.calculationApplyCount()  //计算租期
        }

      } else {
        this.endTime = val
        if(this.parkingMess.monthType==1){
          this.calculationEndDate()  //计算结束日期
        }else{
          this.calculationApplyCount()  //计算租期
        }
      }
      this.$emit('inputChange', { val: { startTime: this.startTime, endTime: this.endTime }, type: 'time' })
    },
    nameInputFun() {
      this.$emit('inputChange', { val: this.userName, type: 'name' })
    },
    parkingNumberInputFun() {
      this.$emit('inputChange', { val: this.parkingNumber, type: 'parkNum' })
    },
    otherPhoneInputFun() {
      this.$emit('inputChange', { val: this.otherPhone, type: 'otherPhone' })
    },
    selectTime(val) {

      if (this.parkingMess.monthType == 2) {
        if(val == 1 && this.parkingMess.ifReletGap == 1){
          return
        }
         this.timeT = val;
         this.userS = true;
         this.$refs.datetime_date.open();
      } else { //按月结束日期自己计算
        if(val ==1){
           this.timeT = val;
           this.userS = true;
           if(this.parkingMess.startDateConf == 1){
             this.$refs.datetime_month.open();
           }else{
              this.$refs.datetime_date.open();
           }

        }
       //
      }
    },

    select(){
           //if() 先选择开始日期
            this.popupVisible=true;
            this.pickList = this.Qishulist;

    },
    onValuesChange (picker, values) {
            if (values[0] > values[1]) {
                picker.setSlotValue(1, values[0]);
            }
    },

    handleConfirm(){
            this.popupVisible = false
            var valve =  this.$refs.picker.getValues()[0];
            this.applyCount=valve
            // var list =this.Qishulist[0].values;
            //计算结束日期
            this.calculationEndDate();

    },

    calculationEndDate(){
          if(! this.startTime || !this.applyCount){
            return;
          }
           var endTime = moment(this.startTime).add(this.applyCount,'month').subtract(1,'day')
           this.endTime =  util.formatTime(new Date(endTime) , 4)
           this.$emit('inputChange', { val: { startTime: this.startTime, endTime: this.endTime }, type: 'time' })
           this.$emit('inputChange', { val: this.applyCount, type: 'applyDay' })
    },
    calculationMonthCount(){
      if(! this.startTime || !this.endTime){
            return;
        }
        console.log(this.startTime)
        console.log(this.endTime)
        let month = moment(this.endTime).add(1, 'day').diff(moment(this.startTime), 'month')
        this.applyCount = month
        this.$emit('inputChange', { val: this.applyCount, type: 'applyDay' })
    },
    calculationApplyCount(){
       if(! this.startTime || !this.endTime){
            return;
        }
        console.log(this.startTime)
        console.log(this.endTime)
        let month = moment(this.endTime).add(1, 'day').diff(moment(this.startTime), 'month')
        this.applyCount =
        month +
        '月' +
        moment(this.endTime)
          .add(1, 'day')
          .subtract(month, 'month')
          .diff(moment(this.startTime), 'day') +
        '天（' +
        moment(this.endTime).diff(moment(this.startTime), 'day') +
        '天）'
         this.applyCountText = this.applyCount
        this.$emit('inputChange', { val: this.applyCount, type: 'applyDay' })

    }
  },
  
};
</script>

<style lang="less" scoped>
@import "../../../assets/css/common.less";
.apply_mess {
  margin-bottom: 14px;
  width: 100%;
  h3 {
    font-size: 30px;
    color: rgba(153, 153, 153, 1);
    line-height: 42px;
    padding: 28px 0 20px 28px;
  }
  .mess_list {
    background: #fff;
    .mess_list_item {
      // padding: 0 28px;
      position: relative;
      border-bottom: 0.02rem solid #BDBDBD;
      .flex();
      height: 100px;
      align-items: center;
      .list_item_left {
        width: 164px;
        font-size: 30px;
        color: rgba(51, 51, 51, 1);
        span {
          color: #fc3f56;
        }
      }
      .list_item_right {
        flex: 1;
        height: 100px;
        .borderB();
        font-size: 30px;
        color: #333;
        box-sizing: border-box;
      }
      .list_item_right_p {
        line-height: 100px;
      }
      .last {
        .borderB(#fff);
      }
      .placeholder {
        color: #c9c9c9;
      }
      img {
        display: block;
        position: absolute;
        right: 28px;
        top: 34px;
        width: 32px;
        height: 32px;
      }
    }
  }
  .mess_list_3{
    padding: 0 20px;
  }
  .mess_list_item_3{
    padding: 0!important;
    border-bottom:2px solid #BDBDBD ;
  }
}
.end_time {
  .flex();
  flex-direction: column;
  justify-content: center;
  align-items: center;
  margin-top: 200px;
  img {
    display: block;
    width: 108px;
    height: 108px;
    margin-bottom: 44px;
  }
  p {
    text-align: center;
    font-size: 30px;
    color: rgba(153, 153, 153, 1);
    line-height: 42px;
  }
}

//pick
.picker {
    width: 100%;
}
.picker-items {
    height: 100px!important;
}
.picker_wrap {
    height: 100px;
    display: flex;
    justify-content: space-between;
    padding: 0 28px;
    box-sizing: border-box;
}
.picker_btn,
.picker_btn2 {
    flex: 1;
    font-size: 32px;
    text-align: left;
    line-height: 100px;
}
.picker_btn2 {
    text-align: right;
    color: @color17;
}

.nodataView{
    width: 100%;
    height: 500px;
    flex: 1;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    display: flex;

  }
  .nodataImage{
    width: 200px;
    height: 200px;
  }
  .nodataspan{
      margin-top: 10px;
    height:40px;
    font-size:28px;
    font-weight:400;
    color:rgba(153,153,153,1);
    line-height:40px;
  }
</style>
